(function(){
'use strict';
var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function each(list, fn){ Array.prototype.forEach.call(list, fn); }
function reveal(){
  var els = document.querySelectorAll('.nv-r:not(.nv-in), .nv-mask:not(.nv-in), .nv-line:not(.nv-in)');
  if (rm || !('IntersectionObserver' in window)) { each(els, function(e){ e.classList.add('nv-in'); }); return; }
  var io = new IntersectionObserver(function(entries){
    each(entries, function(en){ if (en.isIntersecting) { en.target.classList.add('nv-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
  each(els, function(e){ io.observe(e); });
}
function header(){
  var ticking = false;
  function update(){ document.body.classList.toggle('nv-scrolled', window.scrollY > 40); ticking = false; }
  window.addEventListener('scroll', function(){ if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }, { passive: true });
  update();
}
function parallax(){
  if (rm) return;
  var els = document.querySelectorAll('[data-nv-par]');
  if (!els.length) return;
  var ticking = false;
  function update(){
    var vh = window.innerHeight;
    each(els, function(el){
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var s = parseFloat(el.getAttribute('data-nv-par')) || 0.08;
      var p = (r.top + r.height / 2 - vh / 2) / vh;
      el.style.transform = 'translate3d(0,' + (p * s * 100).toFixed(2) + 'px,0)';
    });
    ticking = false;
  }
  window.addEventListener('scroll', function(){ if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }, { passive: true });
  window.addEventListener('resize', function(){ if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }, { passive: true });
  update();
}
function init(){ reveal(); header(); parallax(); }
if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
document.addEventListener('shopify:section:load', function(){ reveal(); parallax(); });
})();
